module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter21"
    }
  }, [_c('h1', [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _c('a', {
    attrs: {
      "href": "#/003toc#ch21"
    }
  }, [_vm._v("Many Bean Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This hearty soup requires soaking the beans overnight and then putting everything in the slow cooker for the day. It’s a colorful, flavorful, and healthful choice for dinner, and your slow cooker makes it a no-brainer for a day when you want to come home to a bowl of comfort food. A loaf of crusty bread or freshly baked cornbread makes the perfect accompaniment.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The choice of beans is up to you; it’s really more about color, texture, and the beans that you like. (You can double up on one type if that appeals.) I like to buy my beans at health food stores where they have bulk-food bins, so that I only buy what I need. Many markets sell a blend of beans for this soup, so you can keep a bag of beans in your pantry just in case of a soup emergency!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("¼ cup dried red beans")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("¼ cup dried small white beans")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("¼ cup dried pinto beans")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("¼ cup dried kidney beans")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("¼ cup dried cranberry beans")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("¼ cup dried baby lima beans")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("¼ cup dried black-eyed peas")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("¼ cup dried green split peas")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("¼ cup dried yellow split peas")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("¼ cup dried red lentils")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("¼ cup dried brown lentils")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1 large onion, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("3 medium carrots, chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("3 stalks celery, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("2 teaspoons dried thyme")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1 bay leaf")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("One 15-ounce can chopped plum tomatoes, with their juice")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("1 smoked ham hock or ham bone")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("8 cups chicken or vegetable broth")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Salt and freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("soak the red, white, pinto, kidney, cranberry, lima beans, and black-eyed peas overnight in water to cover. Drain and rinse thoroughly.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("add the soaked beans, split peas, and lentils to the insert of a 5- to 7-quart slow cooker. Add the remaining ingredients up through the broth and stir to combine.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("cook on low for 8 to 10 hours, until the beans are tender and the ham is falling off the bone.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("remove the ham hock or bone from the soup, chop any meat, removing the fat, and return the meat to the slow-cooker.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("season with salt and pepper. Remove the bay leaf before serving.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("serves 8–10")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "sidebar_head"
  }, [_c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "image 1",
      "src": "images/image-01.jpg"
    }
  }), _vm._v(" slow-cooker savvy")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("When I have ham for a holiday dinner, I will generally freeze the bone after we have cleaned off most of the meat. Then when I want to make soup, I’ll defrost it and place it in the slow cooker with the other ingredients. Ham hocks and smoked hams tend to be salty, so I recommend not salting the soup until close to the end of the cooking time.")])]), _vm._v(" "), _c('p', {
    staticClass: "breakhere"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78409072","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/027-chapter21.vue
// module id = 135
// module chunks = 0